// extracted by mini-css-extract-plugin
export default {"resetLink":"reset_query_message-module__resetLink--UsDkl"};